export default "__VITE_PUBLIC_ASSET__f1ba52e2__"